// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveChangeRequestTypeHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ChangeRequestTypeDTO from '../models/ChangeRequestTypeDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    changeRequestTypeId: number;
    changeRequestType: ChangeRequestTypeDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            changeRequestTypeId: 0,
            changeRequestType: null,
        },
        initValues);
    },
    changeRequestTypeId: 'changeRequestTypeId',
    changeRequestType: 'changeRequestType',
}

interface Result extends ResultDTO {
    changeRequestType: ChangeRequestTypeDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequestType: null,
        },
        initValues);
    },
    changeRequestType: 'changeRequestType',
}

export { Request, Result };